export function removeTrailing(quantities: (number | null)[]): void {
    // remove trailing zeros
    var len = quantities.length;
    for (let i = 0; i < len; i++) {
        var ix = len - 1 - i;
        var last = quantities[ix];
        if (last) {
            break;
        }
        else {
            quantities.pop();
        }
    }
}

export function getQuantity(srcValue: any, allowNegative: boolean = false) {

    if (!srcValue) {
        return null;
    }

    var dstValue = Number(srcValue)

    if (isNaN(dstValue)) {
        return 0;
    }

    if (!allowNegative && dstValue < 0) {
        return 0;
    }
    else {
        return dstValue;
    }
}